import { render, staticRenderFns } from "./index-办公区道闸.vue?vue&type=template&id=4367540a&scoped=true&"
import script from "./index-办公区道闸.vue?vue&type=script&lang=js&"
export * from "./index-办公区道闸.vue?vue&type=script&lang=js&"
import style0 from "./index-办公区道闸.vue?vue&type=style&index=0&id=4367540a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4367540a",
  null
  
)

export default component.exports